"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";

/**
 * Use this component to inject styles into
 * Components
 */

export default class StyledContent extends Component {

    static propTypes = {
        content: PropTypes.content,
        styleClass: PropTypes.style,
        name: PropTypes.string
    };

    render() {
        const { content, styleClass={}, name} = this.props;
        if (content || content === false) {
            return <RenderContent content={content} className={styleClass[name]}/>
        }
        return null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/templates/StyledContent.jsx
 **/